import * as React from 'react';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import i18n from '@i18next/i18n';
import { TOOLBAR_VIDEO } from '@src/framework/editor/src/img/pageIndex';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ENV } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

export const config = {
    id: ActionType.INSERT_VIDEO,
    icon: TOOLBAR_VIDEO,
    content: i18n.t('视频'),
    twdConfig: {
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.PC_TOOLBAR_INSERT,
        action: TDWActionType.VIDEO,
        notReportVer5: true,
    },
};

export const FROM_LOCAL = {
    id: `${config.id}-from-local`,
    content: i18n.t('从本地'),
};

export const FROM_TENCENT_DOCS = {
    id: `${config.id}-from-tencent-docs`,
    content: TENANT_CONFIG.TENANT_DOC_NAME ? `从${TENANT_CONFIG.TENANT_DOC_NAME}` : i18n.t('从腾讯文档'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''} />,
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
    ...[FROM_LOCAL, FROM_TENCENT_DOCS].map(conf => ({
        name: conf.id,
        content: conf.content,
        tooltip: conf.content,
    })),
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''} />,
        text: config.content,
        style: {
            width: 'auto',
        },
        tooltip: i18n.t('插入视频'),
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
    ...[FROM_LOCAL, FROM_TENCENT_DOCS].map(conf => ({
        name: conf.id,
        content: conf.content,
    })),
];
